import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

export function createSettingsForm(_formBuilder: UntypedFormBuilder): UntypedFormGroup {
    return _formBuilder.group({
        exportType: [],
        exportSettings: _formBuilder.array([]),
        writeSettings: _formBuilder.group({})
    });
}

export function createIndividualSettingsForm(_formBuilder: UntypedFormBuilder): UntypedFormGroup {
    return _formBuilder.group({
        id: [],
        defaultColumnName: [, [Validators.required]],
        userColumnName: [, [Validators.required]],
        internalColumnName: [, [Validators.required]],
        include: [, [Validators.required]],
        position: [0, [Validators.required]]
    });
}
